const indexItems = [
  { id: 1, title: '国产剧情片', count: '326部', icon: 'ri-emotion-line', color: 'bg-red-50 text-red-600' },
  { id: 2, title: '都市爱情片', count: '218部', icon: 'ri-heart-line', color: 'bg-pink-50 text-pink-600' },
  { id: 3, title: '动作冒险片', count: '189部', icon: 'ri-fire-line', color: 'bg-orange-50 text-orange-600' },
  { id: 4, title: '悬疑推理片', count: '145部', icon: 'ri-magic-line', color: 'bg-purple-50 text-purple-600' },
  { id: 5, title: '喜剧搞笑片', count: '203部', icon: 'ri-emotion-happy-line', color: 'bg-yellow-50 text-yellow-600' },
  { id: 6, title: '纪录写实片', count: '98部', icon: 'ri-camera-line', color: 'bg-green-50 text-green-600' },
  { id: 7, title: '经典老片回顾', count: '267部', icon: 'ri-history-line', color: 'bg-amber-50 text-amber-600' },
];

export default function IndexSection() {
  return (
    <section id="index" className="section-scroll py-14 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-red-600 text-xs md:text-sm font-semibold tracking-widest uppercase mb-2">分类导航</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900">主题索引</h2>
          <p className="mt-2 text-gray-500 text-sm md:text-base max-w-lg mx-auto">
            按类型快速找到你想看的91精品视频在线播放内容，七大主题分类一目了然
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="group flex flex-col items-center p-5 md:p-6 rounded-xl bg-gray-50 border border-gray-100 hover:border-red-200 hover:bg-red-50/30 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl ${item.color} flex items-center justify-center mb-3 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-gray-900 mb-1 whitespace-nowrap">{item.title}</h3>
              <p className="text-xs text-gray-400">{item.count}</p>
            </a>
          ))}
          {indexItems.length < 7 && (
            <a
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="flex flex-col items-center justify-center p-5 md:p-6 rounded-xl bg-gradient-to-br from-red-50 to-amber-50 border border-red-100 hover:border-red-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-red-600 flex items-center justify-center mb-3">
                <i className="ri-add-line text-white text-xl md:text-2xl"></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-red-600 whitespace-nowrap">更多分类</h3>
              <p className="text-xs text-gray-400">持续更新中</p>
            </a>
          )}
        </div>
      </div>
    </section>
  );
}